export default defineNuxtPlugin(() => {
  if (process.server) return

  const { trackPageView } = useAnalytics()
  const router = useRouter()

  // Track initial page view
  trackPageView()

  // Track subsequent page views
  router.afterEach((to) => {
    nextTick(() => {
      trackPageView(to.path)
    })
  })
})
